import PropTypes from 'prop-types';

import { black3 } from '~/assets/shared-styles/general';

const ReorderIcon = ({ size = '20', color = black3 }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" fill="none">
      <rect x="8" y="2" width="2" height="3" rx="0.8" fill={color} />
      <rect x="8" y="7" width="2" height="3" rx="0.8" fill={color} />
      <rect x="8" y="12" width="2" height="3" rx="0.8" fill={color} />
      <rect x="14" y="2" width="2" height="3" rx="0.8" fill={color} />
      <rect x="14" y="7" width="2" height="3" rx="0.8" fill={color} />
      <rect x="14" y="12" width="2" height="3" rx="0.8" fill={color} />
    </svg>
  );
};

ReorderIcon.propTypes = {
  size: PropTypes.string,
  color: PropTypes.string,
};

export default ReorderIcon;
